import { HTMLProps } from "react";

import { cx } from "@/utils";

import styles from "./Message.module.css";

const Message: React.FunctionComponent<HTMLProps<HTMLDivElement>> = ({
  className,
  ...props
}) => <div className={cx(styles.root, className)} {...props}></div>;

export default Message;
